define(
    'models/BannerModel',[
        'underscore',
        'ObjectModel',
        'LocalStorage',
        'moment',
        'app'
    ],
    function(
        _,
        ObjectModel,
        LocalStorage,
        moment,
        app
    )
    {
        function defaultCart(cart){
            return cart ? cart : app.getCart();
        }

        //
        // Model Banner
        //

        var BannerModelPrototype = {
            name: 'BannerModel',
            idAttribute: 'id_banner',
            route: 'apiBannerModel',
            isModelFetched:false,

            isVisibleInContext: function() {
                //
                // Actif sur le web et sur les device
                //
                if (!this.isActive()) {
                    return false;
                }

                //
                // Disponibilité par période [from,to]
                //
                if (!this.isActiveFromTo()){
                    return false;
                }

                //
                // Disponibilité par mode d'achat [VAE,VAD]
                //
                if (!this.allowDeliveryMode()){
                    return false;
                }

                //
                // Disponibilité par créneau horaire et jour
                //     valeurs dispobibles :
                //         never | always | {from,to,active} | [{from,to,active},...]
                //
                if (!this.isMomentVisible()) {
                    return false;
                }

                // Disponibilité par shop
                if (!this.isShopVisible()) {
                    return false;
                }

                // Disponibilité par groupe client
                if (!this.isCustomerVisible()) {
                    return false;
                }

                // Check filter
                if (app.getTags().isFilterChecked() || app.getAllergenGroups().isFilterChecked()) {
                    return false
                }
                return true
            },

            isActive:function(){
                if (!this.get('active')) {
                    return false
                }

                var isDesktop = app.isDesktop()

                if (isDesktop && (!this.get('desktop') || this.get('nbr_column_desktop') === 0)) {
                    return false
                }

                if (!isDesktop && (!this.get('webmobile') || this.get('nbr_row_mobile') === 0)) {
                    return false
                }

                return true
            },

            isActiveFromTo:function(){
                //
                // disponibilité par période [from,to]
                //
                var from = this.get('from'),
                    to = this.get('to');

                from = from ? from.replace(/-/g,'/') : false;
                to = to ? to.replace(/-/g,'/') : false;
                if (from) {
                    if (moment().isBefore(new Date(from))) {
                        return false;
                    }
                }
                if (to) {
                    if (moment().isAfter(new Date(to))) {
                        return false;
                    }
                }
                return true;
            },

            allowDeliveryMode:function(){
                var cart = defaultCart(cart);

                if (cart.isVAD() && !this.get('vad')) {
                    return false;
                }
                if (cart.isVAE() && !this.get('vae')) {
                    return false;
                }
                return true;
            },

            isMomentVisible: function(fromTo) {
                var now = moment(),
                    visibility = fromTo || this.get('visibility');

                if (visibility == 'always') {
                    return true
                } else if (visibility == 'never'){
                    return false
                } else if (_.isArray(visibility)) {
                    // on utilise l’index du jour du contexte 1 = lundi | 0 = dimanche (c'est faux!)
                    // TODO attention l’API est lundi = 0
                    return this.isMomentVisible(visibility[(now.day()+7-1)%7]);
                } else if (visibility.from && visibility.to) {
                    // si le produit est dans le créneau horaire panier
                    //    isVisible = true;
                    if (!visibility.active) {
                        return false
                    }
                    return now.isBetween(
                        moment(visibility.from, 'hh:mm:ss'),
                        moment(visibility.to, 'hh:mm:ss')
                    );
                } else {
                    // par défault, ce cas ne devrait pas arriver
                    return false;
                }
            },

            isShopVisible: function() {
                if (this.get('all_store')) {
                    return true
                }
                var allowed_shop = this.get('stores'),
                    show_if_no_store = this.get('show_if_no_store'),
                    current_shop = cart.get('id_store');

                if (show_if_no_store && current_shop == '0') {
                    return true
                }
                if (allowed_shop && Array.isArray(allowed_shop) && allowed_shop.includes(current_shop)) {
                    return true
                }

                return false
            },

            isCustomerVisible: function() {
                var customer_group = this.get('customer_group')
                if (!customer_group) {
                    return true
                }

                var current_user_group = app.getCustomer().getCustomerGroup()

                if (_(customer_group).intersection(current_user_group).length !== 0) {
                    return true
                }

                return false

            },

            getPictureUrl: function() {
                var isDesktop = app.isDesktop(),
                    format = false,
                    id_image = false;
                if (isDesktop) {
                    var column = this.get('nbr_column_desktop'),
                        formatBySize = {
                        0: '',
                        1: '300x652',
                        2: '660x652',
                        3: '1320x652',
                    };
                    id_image = this.get('picture_landscape');
                    format = formatBySize[column]
                } else if (!isDesktop) {
                    var column = this.get('nbr_row_mobile'),
                        formatBySize = {
                        0: '',
                        1: '640x206',
                        2: '640x310',
                    };
                    id_image = this.get('picture_portrait') || this.get('picture_landscape')
                    format = formatBySize[column]
                }
                return app.getPictureUrl(id_image, 'Banner', format, 'PNG', id_image)
            },

            getLink: function() {
                if (!this.get('mode_display')) {
                    return this.get('link')
                }

                return false
            },

            getAccessibleActionTitle: function() {
                var model = this,
                    display = model.get('mode_display') || '0',
                    link = model.getLink();

                if (display == '0' && link) {
                    return model.get('link_text')
                } else if (display == '1') {
                    return  app.t('Ajouter au panier', 'discount');
                } else if (display == '2') {
                    var product = app.getProduct(model.get('id_product'));
                    return product ? product.getName() : '';
                } else if (display == '3') {
                    return  app.t('Utiliser le bon de réduction', 'Checkout')
                }

                return ''
            }

        }

        var BannerModel = ObjectModel.extend(LocalStorage).extend(BannerModelPrototype);

        return BannerModel;
    }
);
